import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'
import { IconButton, Typography } from '@mui/material'
import Row from 'components/shared/Row'
import { PaginationParams } from 'redux/slices'
import { getSliceFromPagination } from 'utils/helpers'
import { SmallSelect } from '../../shared/SmallSelect'

export type MorphotypePaginationProps = {
  totalCount: number
  pagination: PaginationParams
  items?: number[]
  showSelect?: boolean
  showPagination?: boolean
  itemsPerPage?: number
  changeItemsPerPage?: (v: number) => void
  changePage?: (p: number) => void
  page?: number
}

export const MorphotypePagination = ({
  totalCount,
  pagination,
  items = [100, 150, 200],
  showSelect = true,
  showPagination = true,
  itemsPerPage,
  changeItemsPerPage,
  changePage,
  page
}: MorphotypePaginationProps): JSX.Element => {
  

  const { startIndex, endIndex } = getSliceFromPagination({
    count: totalCount,
    page: pagination.page ?? 0,
    itemsPerPage: pagination.itemsPerPage ?? items[0],
  })

  const textOutput = `${startIndex + 1}-${endIndex} of ${totalCount}`

  return (
    <Row alignItems="center">
      {showSelect ? (
        <SmallSelect
          items={items}
          value={itemsPerPage ?? 0}
          onChange={(v) => {
            if (changeItemsPerPage) changeItemsPerPage(+v)
          }}
        />
      ) : null}
      {showPagination ? (
        <Row mx={1}>
          <IconButton
            sx={{ p: 0, color: 'rgba(95, 85, 209, 1)' }}
            disabled={startIndex === 0}
            onClick={() => {
              if (changePage) changePage((page || 0) - 1)
            }}
          >
            <ArrowBackIosIcon />
          </IconButton>
          <Typography width="max-content" textAlign="center">
            {textOutput}
          </Typography>
          <IconButton
            sx={{ p: 0, color: 'rgba(95, 85, 209, 1)' }}
            disabled={endIndex === totalCount}
            onClick={() => {
              if (changePage) changePage((page || 0) + 1)
            }}
          >
            <ArrowForwardIosIcon />
          </IconButton>
        </Row>
      ) : null}
    </Row>
  )
}

export default MorphotypePagination
